import React from 'react';
import {imagePath} from "../utils/imageUtils";

function ImageWithFallback(props) {
    return (
        <img
            {...props}
            onError={(e)=>{e.target.onerror = null; e.target.src=imagePath("image_coming_soon.jpg")}}
        />
    );
}

export default ImageWithFallback;